
var getMonthText = (dateString) =>{
  const  months = [
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'aout',
    'septembre',
    'octobre',
    'novembre',
    'décembre'
  ];

  if (dateString.length <= 4) return dateString;

  let date = dateString.split('-');
  let month = parseInt(date[1]) - 1;

  return months[month] + ' ' + date[0];
}
var lastThreeMonths = [];


const getLast12Months =  ()=>{
  let date = new Date();
  let currentYear = date.getFullYear();
  let currentMonth = date.getMonth()+1;
  var last12Months=[];
  for (var x =0  ; x < 12 ; x++) {
    
    let dateString = `${currentYear}-${currentMonth.toString().padStart(2,"0")}`;
    last12Months.push(dateString);

    currentMonth = currentMonth - 1 ;
    if ( currentMonth <= 0 ) {
      currentYear = currentYear -1 ;
      currentMonth = 12;
    }
  }
  return last12Months;
}

(function () {
  let curMonth = new Date().getMonth() + 1;
  let curYear = new Date().getFullYear();
  for (let i = 0; i < 3; i++) {
    curMonth -= 1;
    if (curMonth <= 0) {
      curMonth = 12;
      curYear -= 1;
    }
    let monthK = curYear + '-' + ('0' + curMonth).slice(-2);
    lastThreeMonths.push(monthK);
  }
})();

export {getMonthText};
export {lastThreeMonths}
export {getLast12Months}